import http from '../js/lib/http'

export class BaseService {
  constructor() {
    this.$http = http;
  }
}
